import { Row } from '@simplywallst/ui-core';
import { ExcerptCardWrapper, ExcerptContent } from './styled';

type Props = {
  excerpt: string;
  index: number;
};

export const ArticleDescription = ({ excerpt, index }: Props) => {
  return (
    <Row>
      <ExcerptCardWrapper>
        <ExcerptContent data-cy-id={`article-card-excerpt-${index}`}>
          {excerpt}
        </ExcerptContent>
      </ExcerptCardWrapper>
    </Row>
  );
};
